// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "." + {"378":"02d95d3626d03de87dae","757":"4e13e8ffaba3b176a32b","963":"22afd1c52c9d04a2aacd"}[chunkId] + ".js";
};